import { render, staticRenderFns } from "./ServiceDisplaySolution.vue?vue&type=template&id=d2543520"
import script from "./ServiceDisplaySolution.vue?vue&type=script&lang=js"
export * from "./ServiceDisplaySolution.vue?vue&type=script&lang=js"
import style0 from "./ServiceDisplaySolution.vue?vue&type=style&index=0&id=d2543520&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports